import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from './../shared/shared.module';

import { AuditReportSearchComponent } from './components/audit-report-search/audit-report-search.component';
import { MoneyTransferTableComponent } from './components/money-transfer-table/money-transfer-table.component';
import { SignInLogTableComponent } from './components/sign-in-log-table/sign-in-log-table.component';
import { ReportTableComponent } from './components/report-table/report-table.component';
import { JssModule } from '@sitecore-jss/sitecore-jss-angular';

const ReportingComponents = [
  { name: 'AuditReportSearch', type: AuditReportSearchComponent },
  { name: 'MoneyTransferTable', type: MoneyTransferTableComponent },
  { name: 'SignInLogTable', type: SignInLogTableComponent }
];

@NgModule({
  declarations: [
    AuditReportSearchComponent,
    MoneyTransferTableComponent,
    SignInLogTableComponent,
    ReportTableComponent
  ],
  imports: [CommonModule, JssModule, SharedModule]
})
export class ReportingModule {}
export { ReportingComponents };
